module.exports = __webpack_public_path__ + "img/P150T_weapon_134.76b6ea16.png";